import axiosConfig from "../../../utils/axiosConfig";

const BASE_PATH = "pages/memberships/member_visits";

const createMemberVisitsApi = (module) => {
  const baseUrl = `${BASE_PATH}/${module}`;

  return {
    getFilters(params) {
      return axiosConfig.get(`${baseUrl}/get_filters`, params);
    },
    getData(params) {
      return axiosConfig.post(`${baseUrl}/get_table`, params);
    }
  };
};

export const api = {
  inStoreVsCrossClub: createMemberVisitsApi("in_store_vs_cross_club"),
  crossClubRanking: createMemberVisitsApi("cross_club_ranking")
};
